/** Semantic toast variant; maps to palette family and leading icon in {@link CadsToastComponent}. */
export type CadsToastVariant = 'success' | 'error' | 'info';

/** Default auto-dismiss duration for transient toasts (ms). */
export const CADS_TOAST_DEFAULT_DURATION_MS = 3000;

/** Exit animation duration before a toast is removed from the stack (ms). */
export const CADS_TOAST_EXIT_DURATION_MS = 300;

/** Window within which duplicate {@link CadsToastConfig.dedupeKey} shows are suppressed (ms). */
export const CADS_TOAST_DEDUPE_WINDOW_MS = 3000;

/**
 * Options for {@link CadsGlobalToastService.show}. The host supplies pre-translated copy (no i18n inside CADS v1).
 */
export interface CadsToastConfig {
  /** Pre-translated message shown in the toast body. */
  readonly message: string;
  /** Visual and a11y treatment. Default: `info`. */
  readonly variant?: CadsToastVariant;
  /** Auto-dismiss delay in ms. Default: {@link CADS_TOAST_DEFAULT_DURATION_MS}. */
  readonly durationMs?: number;
  /** When set, suppress duplicate shows with the same key within {@link CADS_TOAST_DEDUPE_WINDOW_MS}. */
  readonly dedupeKey?: string;
}

/** Active toast entry managed by {@link CadsGlobalToastService} and rendered by the global host. */
export interface CadsToastInstance {
  readonly id: string;
  readonly message: string;
  readonly variant: CadsToastVariant;
  readonly exiting: boolean;
}
